const { Component } = React;

const internals = {
  resortCodes: ["BTC", "BBO", "BNG"],
};

class DigitalBrochure extends Component {
  constructor() {
    super();

    this.closeiFrame = this.closeiFrame.bind(this);

    this.state = {
      iframeOpts: {
        iframeURL: null,
        resortShortname: null,
        resortCity: null,
        countryName: null,
      },
      isModalOpen: false,
    };
  }

  handleClick(iframeOpts) {
    return (event) => {
      event.preventDefault();

      this.setState({ iframeOpts, isModalOpen: true });
    };
  }

  closeiFrame() {
    this.setState({ isModalOpen: false });
  }

  renderResortMicroBrochure() {
    const { resortCodes } = internals;
    const { cdnURL, resortList = [] } = this.props;
    const orderResort = resortCodes.map((code) =>
      resortList.find((rstData) => rstData.code === code)
    );

    const elements = orderResort.map((resort) => {
      const { shortName = "", code = "", city = "", countryName = "" } = resort;

      const iframeOpts = {
        iframeURL: `https://cdn.sandals.com/beaches/v11/flipbooks2018/${code}/index.html`,
        shortName: `${shortName}`,
        city: `${city}`,
        countryName: `${countryName}`,
      };

      return (
        <div key={code} className="lg-6 perks">
          <article className="pane">
            <figure>
              <img
                src={`${cdnURL}/general/brochure/${code.toLowerCase()}.jpg`}
                className="img-responsive js-lazy"
                alt="Party at the bar"
              />
            </figure>
            <p className="nunito-bold uppercase">
              Beaches
              <span> {city.replace("Providenciales", "Turks & Caicos")}</span>
            </p>
            <a
              href="#"
              className="learn-more opensans-semibold"
              onClick={this.handleClick(iframeOpts)}
            >
              View Brochure
            </a>
          </article>
        </div>
      );
    });

    return elements;
  }

  render() {
    return (
      <div>
        <div className="main">
          <div className="brochure-header txt-center">
            <h1>DIGITAL BROCHURES</h1>
          </div>

          {this.state.isModalOpen ? (
            <div className="album-cont txt-center">
              <p>{this.state.iframeOpts.resortShortname}</p>
              <span className="show">
                {this.state.iframeOpts.resortCity}{" "}
                {this.state.iframeOpts.countryName}
              </span>
              <div className="iframe-wrapper">
                <iframe
                  src={this.state.iframeOpts.iframeURL}
                  scrolling="no"
                  frameBorder="0"
                />
              </div>
              <a
                href="#"
                className="learn-more txt-center"
                onClick={this.closeiFrame}
              >
                {"<"} Go Back
              </a>
            </div>
          ) : (
            <div className="container tst">
              <div className="row prk-cont">
                {/* {this.renderResortMicroBrochure()} */}

                <div className="lg-6 perks">
                  <article className="pane">
                    <figure>
                      <img
                        src={`https://cdn.sandals.com/beaches/v12/images/brochure/Sandals_WeddingBrochure_Digital.png`}
                        className="img-responsive js-lazy"
                        alt="Party at the bar"
                      />
                    </figure>
                    <p><b>AISLE TO ISLE</b></p>
                    <a
                      href="/aisle-to-isle-magazine/"
                      // href="https://creativestudios.myzen.co.uk/sandals/AisleToIsle_WeddingBrochure2024/"
                      className="learn-more opensans-semibold"
                    >
                      View Brochure
                    </a>
                  </article>
                </div>

                <div className="lg-6 perks">
                  <article className="pane">
                    <figure>
                      <img
                        src={`https://cdn.sandals.com/sandals/v13/images/EN/uploads/Beaches_Brochure_80cfd0af39.jpg`}
                        className="img-responsive js-lazy"
                        alt="Party at the bar"
                      />
                    </figure>
                    <p><b> BEACHES BROCHURE</b></p>
                    <a
                      href="/beaches-brochure/"
                      // href="https://creativestudios.myzen.co.uk/sandals/interimSept2024/"
                      className="learn-more opensans-semibold"
                    >
                      View Brochure
                    </a>
                  </article>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

DigitalBrochure.defaultProps = {
  resortList: [],
  cdnURL: "#",
};

export default DigitalBrochure;
